module.exports = __webpack_public_path__ + "assets/img/copyright-two.6594690e.png";